import { ADD_FOLDER_ID } from './../../action-types/bookproperties';

export const STATE_KEY = 'folderId';

export const folderId = (state = 0, action) => {
  switch (action.type) {
    case ADD_FOLDER_ID: {
      return action.folderId;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/folderId.js